import { createPortal } from 'react-dom';

// 02.9-shared-widgets.md paso b (§5) -- extraido de CommentArea.jsx, sin cambios: el dropdown
// de @menciones (portal-positioned), mismo patron que MentionList.jsx.
const CommentMentionSuggestions = ({ filteredUsers, mentionIndex, coords, onSelect }) => {
    return createPortal(
        <div className="mention-suggestions" style={{
            position: 'fixed',
            bottom: coords.bottom,
            left: coords.left,
            top: coords.top,
            zIndex: 99999
        }}>
            {filteredUsers.map((u, i) => (
                <div
                    key={u.id}
                    className={`mention-item ${i === mentionIndex ? 'selected' : ''}`}
                    onMouseDown={(e) => {
                        e.preventDefault(); // Prevent blur when clicking item
                        onSelect(u);
                    }}
                >
                    <img
                        src={(u['link-profile-img-thumb'] || u['link-profile-img']) || u.image || `https://ui-avatars.com/api/?name=${u.nick}`}
                        className="mention-avatar"
                        alt=""
                        loading="lazy"
                    />
                    <span className="mention-name">{u.nick}</span>
                </div>
            ))}
        </div>,
        document.body
    );
};

export default CommentMentionSuggestions;
